<template>
  <div style="position: relative;">
    <Breadcrumbnav :breadcrumb="breadcrumb" :showBread="true" />
    <div class="documentos_tudo mainmenu" v-if="!hideMenu">
      <div class="wrap2">
        <div class="row servico_header">
          <div class="small-12 medium-7 large-8 columns servico_title">
            <h1>{{ title }}</h1>
          </div>
          <div class="small-12 medium-5 large-4 columns servico_menu">
            <div class="row" v-for="section in MenuSections" :key="section.path">
              <RouterLink :to="section.path" active-class="active" v-if="section.path != null">
                {{ section.title }}
              </RouterLink>
              <a :href="section.url" target="_blank" v-else>
                {{ section.title }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbnav from '@/components/breadcrumbnav.vue';

export default {
  props:["hideMenu","title","routes","breadcrumb"],
  components: {
    Breadcrumbnav
  },
  setup(props) {

    const MenuSections = Object.values(props.routes).filter(el => el.showOnMenu);
        
    return {
      MenuSections
    };
  },
};
</script>

<style scoped>
/*#region Layout*/
.wrap2 {
  padding-right: 10%;
  padding-left: 10%;
}

.documentos_tudo {
  max-width: 100rem;
  padding-right: 0px;
  padding-left: 0px;
  padding-top: 0px;
  margin: 0 auto 50px;
}

.documentos_tudo.mainmenu {
  margin-bottom: 0;
}

.documentos_tudo.slot{
  padding-top: 15px;
}

@media (min-width: 1400px) {
  .wrap2 {
    padding-left: 15%;
    padding-right: 15%;
    max-width: 100%;
    margin: 0;
  }
}

@media (max-width: 767px) {
  .navwrapper {
    display: none;
  }

  .wrap2 {
    padding-right: 5%;
    padding-left: 5%;
  }

  .documentos_tudo {
    padding-top: 0;
  }
}

/*#endregion*/

/*#region Menu*/
.row.servico_header .row {
  margin-left: 0;
  margin-right: 0;
}

.geral_data .row {
  margin-right: 0px;
  margin-left: 0px;
}

.servico_header {
  height: 550px;
  padding-top: 70px;
  padding-bottom: 40px;
}

.servico_title {
  background-color: #489ad4;
}

.servico_title h1 {
  font-family: "Montserrat Bold";
  color: white;
  padding-top: 40px;
  padding-right: 90px;
  padding-left: 40px;
}

.servico_menu {
  padding-left: 0;
  padding-right: 0;
  padding-top: 55px;
  background-color: #a7d1e6;
}

.servico_menu .row:hover {
  background-color: #79b2dc;
}

.servico_menu .row:first-child {
  border-top: 1px solid #79b2dc;
}

.servico_menu .row {
  border-bottom: 1px solid #79b2dc;
  padding-left: 0px;
  padding-right: 0px;
}

.servico_menu a,
.servico_menu span {
  font-family: "Montserrat SemiBold";
  color: white;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 20px;
  width: 100%;
}

.servico_menu .row.active,
.servico_menu .row .active {
  background-color: #489ad4;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .servico_title h1 {
    font-size: 30px;
    padding-right: 20px;
    padding-left: 20px;
  }
}

@media (max-width: 767px) {
  .row .row {
    margin-left: 0;
  }

  .servico_header {
    height: auto;
    padding-bottom: 20px;
    padding-top: 0;
    margin-bottom: 15px;
    margin-top: 15px;
  }

  .servico_title h1 {
    padding-top: 20px;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 20px;
    font-size: 20px;
  }

  .servico_menu {
    margin-right: 0;
    margin-left: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }

  .servico_menu .row:first-child {
    border-top: 1px solid #79b2dc;
  }

  .servico_menu .row {
    margin-right: 0;
    margin-left: 0;
  }

  .servico_menu .row.active,
  .servico_menu .row .active {
    background-color: #79b2dc;
  }

  .servico_menu a {
    font-family: "Montserrat Semibold";
    font-size: 12px !important;
    text-transform: uppercase;
  }

  .servico_menu .row:last-child {
    border-bottom: 1px solid transparent;
  }

  .servico_header {
    margin-bottom: 0px;
  }
}
/*#endregion*/
</style>